// @flow
import { UPDATE_NETWORK_AVAILABILITY, UPDATE_SERVER_REACHABILITY, } from '../actions/sensors';

import type { Action } from './types';

const initialState = {
    isNetworkAvailable: true,
    isServerReachable: true
};

export default function search( state = initialState, action: Action ) {
    switch ( action.type ) {
        case UPDATE_NETWORK_AVAILABILITY:
            return { ...state, isNetworkAvailable: action.isNetworkAvailable };
        case UPDATE_SERVER_REACHABILITY:
            return { ...state, isServerReachable: action.isServerReachable };
        default:
            return state;
    }
}
